export default {
  logout: "Ви вишли из системи",
  "auth/user-not-found": "Такого пользователя не существует",
  "auth/wrong-password": "Неправильный пароль"
};
